export default function PageTitle({ children }: { children: React.ReactNode }) {
  return <title>{`${children} – Recap Innovations`}</title>;
}
